import { TAG_PUNKT, type TagFarbe } from "./formular/auswahl-konfiguration";

/**
 * Tag-Chip: neutraler Chip mit Farbpunkt in einem von vier festen Farb-Tokens (primär, grün, orange, grau).
 * Gemeinsame Optik von `TagAuswahl` (Formular) und Kanban-Karte; die Farbe bestimmt der Aufrufer, der Text trägt
 * die Aussage (der Punkt ist nur Marker). Abweichung AW-006: Farbpunkt statt Bild-Avatar.
 */
export function TagChip({ farbe, children }: { farbe: TagFarbe; children: React.ReactNode }) {
  return (
    <>
      {/* Preline: component/advanced-select/advanced-select-tags */}
      {/* Abweichung AW-006: Tag-Chip mit Farbpunkt in einem von vier festen Farb-Tokens statt Bild-Avatar */}
      <span className="py-0.5 px-2 inline-flex items-center gap-x-1.5 text-xs font-medium rounded-full bg-layer border border-layer-line text-layer-foreground">
        <span className={TAG_PUNKT[farbe]} aria-hidden="true" />
        {children}
      </span>
    </>
  );
}
